/* eslint-disable camelcase */
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  PaginationPayload,
  UserDetailsResponse,
  UsersListResponse,
  updateUserActiveStatusPayload,
} from './types'

const API_ENDPOINT = '/api/v1/user'

const usersApi = createApi({
  reducerPath: 'usersApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['usersApi'],
  endpoints: (builder) => ({
    getUsersList: builder.query<UsersListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '', userTypeFilter = '' }) => ({
        url: `${API_ENDPOINT}/admin_users_list/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }${userTypeFilter ? `&user_type=${userTypeFilter}` : ''}`,
        method: 'GET',
      }),
      transformResponse: (response: UsersListResponse) => {
        return response
      },
    }),

    getUserDetailsById: builder.query<UserDetailsResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_user_detail/${id}/`,
        method: 'GET',
      }),
      transformResponse: (response: UserDetailsResponse) => {
        return response
      },
    }),

    updateUserActiveStatus: builder.mutation<void, updateUserActiveStatusPayload>({
      query: ({ id, isActive }) => ({
        url: `${API_ENDPOINT}/admin_user_detail/${id}/`,
        method: 'PATCH',
        data: {
          is_active: isActive,
        },
      }),
    }),

    deleteUser: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_user_detail/${id}/`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useGetUsersListQuery,
  useGetUserDetailsByIdQuery,
  useUpdateUserActiveStatusMutation,
  useDeleteUserMutation,
} = usersApi
export default usersApi
